
import '../styles/Navbar.css';
import { HashLink as Link } from 'react-router-hash-link';


/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";

function Navbar() {
    const [sticky, setSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setSticky(window.scrollY > 200);
            console.log(window.scrollY);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    });
    return (
        <nav className={`${sticky ? "sticky" : ""}`}>
            <div className="nav-inner">
                <div className="logo-link">
                    <Link smooth to='#profile'>Hans Snelders</Link>
                </div>
                <div className="links">
                    <Link smooth to='#projects'>Tekeningen</Link>
                    <Link smooth to='#about'>Over mij</Link>
                    <Link smooth to='#contact'>Contact</Link>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;